import { useEffect, useState } from "react";

export const BootOverlay = () => {
  const [phase, setPhase] = useState("show");

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      setPhase("gone");
      return;
    }
    const t1 = setTimeout(() => setPhase("fade"), 1000);
    const t2 = setTimeout(() => setPhase("gone"), 1750);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (phase === "gone") return null;

  return (
    <div
      data-testid="boot-overlay"
      className={`fixed inset-0 z-[80] bg-[#0C1412] flex items-center justify-center transition-opacity duration-700 ${
        phase === "fade" ? "opacity-0" : "opacity-100"
      }`}
    >
      <img src="/logo-mark.png" alt="Novare Estates" className="boot-mark w-24 h-24" />
    </div>
  );
};
